import { pcgSettingsDevelopment } from './pcg-settings-Development';

import { pcgSettingsDemo } from './pcg-settings-Demo';

import { pcgSettingsProduction } from './pcg-settings-Production';


export const pcgSettings = (document.getElementById('systemMode')?.textContent === 'Development') ? pcgSettingsDevelopment :
	
(document.getElementById('systemMode')?.textContent === 'Demo') ? pcgSettingsDemo :
	
(document.getElementById('systemMode')?.textContent === 'Production') ? pcgSettingsProduction :
	
pcgSettingsDevelopment
;
